import React, { useEffect, useRef } from 'react';
import sanitizeRichText from "v4/utils/sanitizeRichText";
import initPluginsForTextareaRenderer from "v4/components/form/ShowField/components/TextareaRenderer/plugins/plugins";
import useCidImages from "v4/components/form/Field/components/InputRichText/hooks/useCidImages";

export default function TextareaRenderer({ value, className, formMetadata }) {
    const shadowDomRef = useRef(null);
    const { processedValue } = useCidImages(sanitizeRichText(value), formMetadata.files);

    useEffect(() => {
        if (!value || !shadowDomRef.current) return;

        try {
            shadowDomRef.current.attachShadow({ mode: 'open' });
        } catch (e) {
            // Shadow DOM already attached
        }

        const shadowRoot = shadowDomRef.current.shadowRoot;

        shadowRoot.innerHTML = processedValue;
        initPluginsForTextareaRenderer(shadowRoot, formMetadata);
    }, [processedValue, value, formMetadata]);

    return (
        <span className={className} ref={shadowDomRef} />
    )
}
